import { create } from 'zustand';
import { PalType } from '../types/Pal';

interface FiltersState {
  // Stato dei filtri
  selectedTypes: PalType[];
  zipCode: string;
  searchRadius: number;
  
  // Stato UI
  isOpen: boolean;
  selectedCategory: string;
  selectedSubcategory: string;
  selectedType: string;
  
  // Azioni
  setSelectedTypes: (types: PalType[]) => void;
  setZipCode: (zipCode: string) => void;
  setSearchRadius: (radius: number) => void;
  setIsOpen: (isOpen: boolean) => void;
  setSelectedCategory: (category: string) => void;
  setSelectedSubcategory: (subcategory: string) => void;
  setSelectedType: (type: string) => void;
  clearAllFilters: () => void;
}

export const useFiltersStore = create<FiltersState>((set) => ({
  // Valori iniziali
  selectedTypes: [],
  zipCode: '',
  searchRadius: 20,
  isOpen: false,
  selectedCategory: '',
  selectedSubcategory: '',
  selectedType: '',
  
  // Azioni
  setSelectedTypes: (types) => set({ selectedTypes: types }),
  setZipCode: (zipCode) => set({ zipCode }),
  setSearchRadius: (radius) => set({ searchRadius: radius }),
  setIsOpen: (isOpen) => set({ isOpen }),
  setSelectedCategory: (category) => set({ selectedCategory: category }),
  setSelectedSubcategory: (subcategory) => set({ selectedSubcategory: subcategory }),
  setSelectedType: (type) => set({ selectedType: type }),
  
  clearAllFilters: () => set({
    selectedTypes: [],
    zipCode: '',
    searchRadius: 20,
    selectedCategory: '',
    selectedSubcategory: '',
    selectedType: '',
  }),
}));

